// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d3da0e08]::-webkit-media-controls-panel,[data-v-d3da0e08]::-webkit-media-controls-play-button{display:none!important;-webkit-appearance:none}[data-v-d3da0e08]::-webkit-media-controls-start-playback-button{display:none!important;-webkit-appearance:none}", ""]);
// Exports
module.exports = exports;
